var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1975 0.986761C17.0807 0.794004 16.801 0.794004 16.6843 0.986761L11.035 10.3128C10.9933 10.3817 10.9255 10.431 10.847 10.4494L0.231693 12.9403C0.0122888 12.9917 -0.0741321 13.2577 0.0731091 13.4283L6.61267 21.0059L16.9408 17.1329L6.8201 27.2536L6.35744 32.7695C6.3386 32.9941 6.56485 33.1585 6.77261 33.0711L16.8246 28.8468C16.899 28.8155 16.9828 28.8155 17.0571 28.8468L27.1091 33.0711C27.3169 33.1585 27.5431 32.9941 27.5243 32.7695L26.6129 21.9041C26.6062 21.8237 26.6321 21.744 26.6848 21.683L33.8086 13.4283C33.9559 13.2577 33.8694 12.9917 33.65 12.9403L23.0348 10.4494C22.9563 10.431 22.8885 10.3817 22.8467 10.3128L17.1975 0.986761Z",
    fill: "#F2994A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.10aadca5f58c3cc9a96a5d57bafcdf29.svg";
export { ForwardRef as ReactComponent };